import React from 'react';
import { AdapterProps } from '../types';
import AssociationField from '../../ReferencesField/ReferencesField';

export type ReferencesAdapterProps = AdapterProps['references'];

const ReferencesAdapter = React.forwardRef(
  (props: ReferencesAdapterProps, ref) => {
    const { label, name, rules, references, ...rest } = props;

    return (
      <div>
        {references.map((item) => (
          <AssociationField
            name={item.name}
            url={item.url}
            label={item.label}
          />
        ))}
      </div>
    );
  },
);

export default ReferencesAdapter;
